import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { Pagination, A11y, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import axios from 'axios';

const ProjectSection = () => {
    const [project, setProject] = useState([]);
    const [categories, setCategories] = useState([]);

    useEffect(() => {
        const fetchProjectsAndCategories = async () => {
            try {
                const [projectsRes, categoriesRes] = await Promise.all([
                    axios.get(`https://api.rashtechinfo.com/getAllProjects`),
                    axios.get(`https://api.rashtechinfo.com/getAllProjectCategories`)
                ]);
              
               const ress = projectsRes.data.data.filter((item)=>{
                    if(item.selected){
                        return item
                    }
                })
               
                
                // setProject(projectsRes.data.data || []);
                setProject(ress || [])
                setCategories(categoriesRes.data.categories || []);
            } catch (error) {
                console.log(error);
            }
        };
        fetchProjectsAndCategories();
    }, []);

    const getCategoryName = (categoryId) => {
        const cat = categories.find(c => c._id === categoryId);
        return cat ? cat.categoryName : '';
    };

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    };

    // Render Swiper only if project data is loaded
    if (project.length === 0) return null;

    return (
        <section className="portfolio_section xb-hidden section_space pb-0">
            <div className="container">
                <div className="heading_block">
                    <div className="row align-items-end">
                        <div className="col-lg-7">
                            <div className="heading_focus_text">
                                <span className="badge bg-secondary text-white">Crafting</span>
                                Success With Project
                            </div>
                            <h2 className="heading_text">
                                Our Recent Best Works
                            </h2>
                            <p className="heading_description mb-0">
                                Our recent projects highlight our expertise in delivering tailored solutions that meet the unique needs and objectives of our clients, custom software.
                            </p>
                        </div>
                        <div className="col-lg-5 d-none d-lg-flex justify-content-end">
                            <Link onClick={ClickHandler} to={'/portfolio'} className="btn btn-primary">
                                <span className="btn_label" data-text="All Works">All Works</span>
                                <span className="btn_icon">
                                    <i className="fa-solid fa-arrow-up-right"></i>
                                </span>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>

            <div className="portfolio_carousel">
                <Swiper
                    key={project.length} // force re-init when project data changes
                    modules={[Pagination, A11y, Autoplay]}
                    slidesPerView={1}
                    loop={true}
                    spaceBetween={30}
                    allowTouchMove={true}
                    centeredSlides={true}
                    speed={600}
                    parallax={true}
                    initialSlide={0}
                    pagination={{ clickable: true }}
                    autoplay={{
                        delay: 3000,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: true,
                    }}
                    breakpoints={{
                        1025: {
                            slidesPerView: 2,
                        },
                    }}
                >
                    {project.slice(0, 5).map((projectItem, prj) => (
                        <SwiperSlide key={prj}>
                            <Link onClick={ClickHandler} to={`/portfolio/${projectItem.Project_title.replace(/\s+/g, "-")}`}>
                                <div className="portfolio_block">
                                    <div className="portfolio_image">
                                        <Link 
                                            onClick={ClickHandler} 
                                            className="portfolio_image_wrap bg-light" 
                                            to={`/portfolio/${projectItem.Project_title.replace(/\s+/g, "-")}`}
                                        >
                                            <img 
                                                src={`https://api.rashtechinfo.com/uploads/${projectItem.projectImage}`} 
                                                alt={projectItem.Project_title}  
                                            />
                                        </Link>
                                    </div>
                                    <div className="portfolio_content">
                                        <ul className="category_list unordered_list" style={{ marginBottom: '15px' }}>
                                            <li>
                                                <Link onClick={ClickHandler} to={`/portfolio/${projectItem.Project_title.replace(/\s+/g, "-")}`}>
                                                    <i className="fa-solid fa-tags"></i>{" "}
                                                    {getCategoryName(projectItem.projectCategory)}
                                                </Link>
                                            </li>
                                        </ul>
                                        <h3 className="portfolio_title">
                                            <Link onClick={ClickHandler} to={`/portfolio/${projectItem.Project_title.replace(/\s+/g, "-")}`}>
                                                {projectItem.Project_title}
                                            </Link>
                                        </h3>
                                    </div>
                                </div>
                            </Link>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>

            <div className="container text-center d-block d-lg-none">
                <div className="btns_group pb-0">
                    <Link onClick={ClickHandler} className="btn btn-primary" to="/portfolio">
                        <span className="btn_label" data-text="All Works">All Works</span>
                        <span className="btn_icon">
                            <i className="fa-solid fa-arrow-up-right"></i>
                        </span>
                    </Link>
                </div>
            </div>
        </section>
    );
};

export default ProjectSection;
